import { Modal, Button } from 'antd';
import { useEffect, useState, useContext } from 'react';
import { DialogContext } from '../../AppContext';
import { COLOR } from '../../Color';
import IC_WARNING from '../../images/ic_warning.svg'
import IC_CLOSE from '../../images/ic_close.svg'
import BaseButton from './BaseButton';

export default function BaseDialog(props) {
    const [visible, setVisible] = useState(false)
    const [customProps, setCustomProps] = useState({})
    const { dialogData, hideDialog } = useContext(DialogContext)
    // const [onLeft, setOnLeft] = useState(null)
    // const [onRight, setOnRight] = useState(null)
    const [left, setLeft] = useState(null)
    const [right, setRight] = useState(null)
    const [leftColor, setLeftColor] = useState('white')
    const [rightColor, setRightColor] = useState(COLOR.orange)
    const [message, setMessage] = useState('')
    const [noIcon, setNoIcon] = useState(false)
    const [type, setType] = useState(null);

    useEffect(() => {
        console.log("DIALOG DATA: ", dialogData)
        if (dialogData && dialogData.visible) {
            setVisible(dialogData.visible)
            if (dialogData.message)
                setMessage(dialogData.message)
            else setMessage(null)

            if (dialogData.noIcon)
                setNoIcon(dialogData.noIcon)
            else setNoIcon(false);

            if (dialogData.type)
                setType(dialogData.type)
            else setType(null);

            if (dialogData.customStyle)
                setCustomProps(dialogData.customStyle)
            else setCustomProps({});

            // if (dialogData.onLeft)
            //     setOnLeft(dialogData.onLeft)
            // else setOnLeft(null);

            // if (dialogData.onRight)
            //     setOnRight(dialogData.onRight)
            // else setOnRight(null)

            if (dialogData.left)
                setLeft(dialogData.left)
            else setLeft(null)

            if (dialogData.right) setRight(dialogData.right)
            else setRight(null)

            if (dialogData.leftColor) setLeftColor(dialogData.leftColor)
            else setLeftColor('white')

            if (dialogData.rightColor) setRightColor(dialogData.rightColor)
            else setRightColor(COLOR.orange)
        } else setVisible(false)
        return () => { }
    }, [dialogData])

    const clickLeft = async () => {
        // onLeft && onLeft()
        hideDialog()
        if (dialogData.onLeft) {
            // console.log("====== ON LEFT ======", dialogData.onLeft)
            dialogData.onLeft()
        }
    }

    const clickRight = async () => {
        hideDialog()
        dialogData.onRight && dialogData.onRight()
    }

    return (
        <>
            {
                visible ?
                    <div className='dialog'>
                        <div onClick={hideDialog} style={{ backgroundColor: 'black', opacity: '0.2', width: '100%', height: '100%', zIndex: 0, position: 'fixed', top: 0, left: 0 }} />
                        <div
                            className='flex-verti panel-radius shadow-4 no-padding'
                            style={{ zIndex: 1, backgroundColor: 'white', width: dialogData.width ? dialogData.width : '80%', position: 'relative', ...customProps }}>
                            {noIcon ? null : <img src={IC_WARNING} style={{ marginTop: '10px' }} />}
                            <div style={{ padding: '14px' }}>
                                {message ? message : null}
                            </div>
                            {
                                type === 'close' ? <BaseButton onClick={hideDialog} className='no-shadow' style={{ width: '30px', height: '30px', position: 'absolute', top: '10px', right: '10px' }}><img src={IC_CLOSE} style={{ fill: 'white' }} /></BaseButton>
                                    :
                                    <div className='flex-hori no-margin no-padding' style={{ width: '100%', height: '40px' }}>
                                        {
                                            type === 'ok' ? <div onClick={() => { dialogData.onOK && dialogData.onOK(); hideDialog() }}>OK</div>
                                                : [
                                                    <div onClick={clickLeft}
                                                        style={{
                                                            flex: 1,
                                                            height: '100%',
                                                            border: (leftColor === 'white') ? '1px solid rgba(196, 196, 196, 0.5)' : `1px solid ${leftColor}`,
                                                            backgroundColor: leftColor,
                                                            color: (leftColor === 'white') ? COLOR.text : 'white',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}>
                                                        {left ? left : 'KHÔNG'}
                                                    </div>,
                                                    <div onClick={clickRight}
                                                        style={{
                                                            flex: 1,
                                                            height: '100%',
                                                            border: (rightColor === 'white') ? '1px solid rgba(196, 196, 196, 0.5)' : `1px solid ${rightColor}`,
                                                            backgroundColor: rightColor,
                                                            color: (rightColor === 'white') ? COLOR.text : 'white',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}>
                                                        {right ? right : 'CÓ'}
                                                    </div>
                                                ]
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                    : null
            }
        </>
    )
}